import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";
import type { PortalDealRow } from "@colab/shared";

// GET /api/portal/deals
//
// Phase 7 sub-bucket 5 — partner-portal deals rich rebuild.
//
// Returns the unified deals feed: partner-submitted `deals` rows (EUR-only,
// internal status) merged with HubSpot-attribution rows (multi-currency,
// stage-driven). Discriminated by `source: 'deal' | 'attribution'`.
//
// The list page filters client-side by tab (Open / Closed / All) — mirrors
// the MDF sub-bucket 3 pattern, keeps the network call cacheable across tab
// switches.
export function useDealsList() {
  return useQuery<PortalDealRow[]>({
    queryKey: queryKeys.portal.deals.list(),
    queryFn: () => apiFetch<PortalDealRow[]>("/portal/deals"),
  });
}
